// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/companies/workspace_rate_limits_data_table" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { companiesWorkspaceRateLimitsDataTable, restUsersTrack, sdkV3Data } from "./constants";
import type {
  CompaniesWorkspaceRateLimitsDataTableParams,
  CompaniesWorkspaceRateLimitsDataTableResult,
} from "./types";

export const getDataTableCompaniesWorkspaceRateLimitsDataTable = reactQueryTableFetcherAdapter(
  companiesWorkspaceRateLimitsDataTable,
  (
    signal: AbortSignal,
    { appGroupId, query = {}, limit = 20, start = 0 }: CompaniesWorkspaceRateLimitsDataTableParams
  ): Promise<CompaniesWorkspaceRateLimitsDataTableResult> => {
    const endpointQuery = query.endpoint;
    if (endpointQuery) {
      if (endpointQuery === restUsersTrack) {
        query.endpoint = "0";
        query.type = "rest";
      } else if (endpointQuery === sdkV3Data) {
        query.endpoint = "1000";
        query.type = "sdk";
      }
    }
    return fetch(
      `/companies/workspace_rate_limits_data_table`,
      "GET",
      {
        app_group_id: appGroupId,
        limit,
        start,
        query: serializeQueryObjects(query),
      },
      { signal }
    );
  }
);
